const ALONGSLIDE_DESKTOP_ADS = {
  alongslide1: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_1",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-1",
    shouldRefresh: false,
  },
  alongslide2: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_2",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-2",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide3: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_3",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-3",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide4: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_4",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-4",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide5: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_5",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-5",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide6: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_6",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-6",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide7: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_7",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-7",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide8: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_8",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-8",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide9: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_9",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-9",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide10: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Desktop_10",
    },
    sizes: [
      [300, 50],
      [320, 50],
      [375, 60],
      [468, 60],
    ],
    id: "alongslide-player-desktop-ad-10",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
}

const ALONGSLIDE_MOBILE_ADS = {
  alongslide1: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_1",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-1",
    shouldRefresh: false,
  },
  alongslide2: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_2",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-2",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide3: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_3",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-3",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide4: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_4",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-4",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide5: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_5",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-5",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide6: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_6",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-6",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide7: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_7",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-7",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide8: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_8",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-8",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide9: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_9",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-9",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
  alongslide10: {
    paths: {
      default: "Slideshow_Page_Alongside_Preso_Mobile_10",
    },
    sizes: [
      [300, 50],
      [320, 50],
    ],
    id: "alongslide-player-mobile-ad-10",
    shouldRefresh: false,
    skipInitializationOnPageLoad: true,
  },
}

export const ADS_BY_SIZE = {
  desktop: {
    ...ALONGSLIDE_DESKTOP_ADS,
    abovePlayer: {
      paths: {
        default: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_No_Refresh",
        30: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Reader_Incl_Large_Leaderboard_240_Sec_Refresh",
      },
      sizes: [
        [728, 90],
        [970, 90],
      ],
      id: "above-player-desktop-ad",
      shouldRefresh: true,
    },
    aboveRecs: {
      paths: {
        default: "Slideshow_Page_Above_Recs_Desktop_No_Refresh",
        30: "Slideshow_Page_Above_Recs_Desktop_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Recs_Desktop_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Recs_Desktop_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Recs_Desktop_240_Sec_Refresh",
      },
      sizes: [
        [300, 250],
        [200, 200],
        [336, 280],
        [250, 250],
      ],
      id: "above-recs-desktop-ad",
      shouldRefresh: true,
    },
  },
  mobile: {
    ...ALONGSLIDE_MOBILE_ADS,
    abovePlayer: {
      paths: {
        default: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_No_Refresh",
        30: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_30_Sec_Refresh",
        60: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_60_Sec_Refresh",
        120: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_120_Sec_Refresh",
        240: "Slideshow_Page_Above_Reader_Incl_Large_Mobile_Web_240_Sec_Refresh",
      },
      sizes: [
        [320, 50],
        [300, 50],
      ],
      id: "above-player-mobile-ad",
      shouldRefresh: true,
    },
    aboveRecs: {
      paths: { default: "Slideshow_Page_Above_Recs_Mobile_Web" },
      sizes: [
        [200, 200],
        [300, 250],
        [250, 250],
        [336, 280],
      ],
      id: "above-recs-mobile-ad",
      shouldRefresh: false,
    },
  },
  responsive: {
    belowReader: {
      paths: { default: "Slideshow_Page_Below_Reader_Incl_Large_Leaderboard" },
      sizes: [
        [200, 200],
        [250, 250],
        [300, 50],
        [300, 250],
        [320, 50],
        [728, 90],
        [970, 90],
      ],
      id: "below-reader-ad",
      shouldRefresh: false,
      sizeMapping: [
        // If screen is wider than 970px, show either 970 or 728px wide
        [
          [970, 768],
          [
            [970, 90],
            [728, 90],
          ],
        ],
        // If screen is between 728px and 970px wide, show 728px wide
        [[728, 480], [[728, 90]]],
        // If screen is between 320px and 728px wide, show either 300 or 320px wide
        [
          [320, 300],
          [
            [300, 50],
            [300, 250],
            [320, 50],
          ],
        ],
        // If screen is between 250 and 320px wide, show either 200 or 250px wide
        [
          [250, 200],
          [
            [200, 200],
            [250, 250],
          ],
        ],
        // If screen is less than 250px wide, show no ads
        [[0, 0], []],
      ],
    },
    betweenRecs1: {
      paths: { default: "Slideshow_Page_Between_Below_Fold_Carousels_Many_Formats" },
      sizes: [
        [200, 200],
        [250, 250],
        [300, 250],
        [336, 280],
        [468, 60],
        [728, 90],
        [970, 90],
        [970, 250],
      ],
      id: "between-recs-ad-1",
      shouldRefresh: false,
      sizeMapping: [
        [
          [970, 768],
          [
            [970, 90],
            [970, 250],
          ],
        ],
        [
          [728, 480],
          [
            [728, 90],
            [468, 60],
          ],
        ],
        [
          [336, 300],
          [
            [300, 250],
            [336, 280],
          ],
        ],
        [
          [250, 200],
          [
            [200, 200],
            [250, 250],
          ],
        ],
        [[0, 0], []],
      ],
    },
    betweenRecs2: {
      paths: { default: "Slideshow_Page_Between_Below_Fold_Carousels_Many_Formats_2" },
      sizes: [
        [200, 200],
        [250, 250],
        [300, 250],
        [336, 280],
        [468, 60],
        [728, 90],
        [970, 90],
        [970, 250],
      ],
      id: "between-recs-ad-2",
      shouldRefresh: false,
      sizeMapping: [
        [
          [970, 768],
          [
            [970, 90],
            [970, 250],
          ],
        ],
        [
          [728, 480],
          [
            [728, 90],
            [468, 60],
          ],
        ],
        [
          [336, 300],
          [
            [300, 250],
            [336, 280],
          ],
        ],
        [
          [250, 200],
          [
            [200, 200],
            [250, 250],
          ],
        ],
        [[0, 0], []],
      ],
    },
  },
}
